import { Tokens, TokensBootstrap } from './types';

import { colors, colorsBootstrap } from './colors';

export const tokens: Tokens = {
	dialogWidth: {
		dialogSmall: '560px',
		dialogMedium: '800px'
	},
	pageWidth: '1440px',
	inputWidth: {
		inputSmall: '128px',
		inputMedium: '328px',
		inputLarge: '384px',
		inputXLarge: '536px'
	},
	colors
};

export const tokensBootstrap: TokensBootstrap = {
	dialogWidth: {
		dialogSmall: '560px',
		dialogMedium: '800px'
	},
	pageWidth: '1440px',
	inputWidth: {
		inputSmall: '128px',
		inputMedium: '328px',
		inputLarge: '384px',
		inputXLarge: '536px'
	},
	colorsBootstrap
};
